import type { IconSvgObject } from './types';

const CodeSquareIcon: IconSvgObject = [
  ["path", { d: "M21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5L19.5 21.5C20.6046 21.5 21.5 20.6046 21.5 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 9.5L17 12L14.5 14.5M9.5 9.5L7 12L9.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CodeSquareIcon;
